<div class="modal-header">
  <app-summary-top
    class="w-100"
    [header]="header()"
    [model$]="model$"
    [showSave]="false"
    [showBack]="true"
  ></app-summary-top>
</div>

<div class="modal-body p-3">
  <app-report-toolbar></app-report-toolbar>
</div>

<!-- The batch's combined PDF — one page per record, in the order the caller supplied.
     Stamped inside the toolbar so the page/zoom controls and the Email/Download/Print
     buttons sit in one strip above it, exactly as on a single-document report tab. -->
<ng-template #preview>
  <app-document-preview
    [documentType]="documentType()"
    [reportIds]="reportIds()"
    [title]="header()"
  ></app-document-preview>
</ng-template>
